 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		69: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		69: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"buybox~collections~collections-mobile~fulfillment~paint-reorder~paint-reorder-mobile~pep~pep-mobile~~45c9a216","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","3":"browse-and-search~browse-and-search-mobile~buybox~collections~collections-mobile~media-gallery-overl~de52b3ab","4":"browse-and-search~browse-and-search-mobile~compare~orange-lens~product-mobile~vendor-collections~ven~4e47053e","5":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~product-mobile","6":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","7":"BuyItAgainTypeaheadPreWrapper","8":"buybox~fulfillment~super-sku","9":"buybox~promotion-products-lazy~quick-view","10":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","11":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","12":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~consumer-card-messaging","15":"compare~orange-lens","16":"media-gallery-overlay~media-gallery-overlay-mobile","18":"StoreLayout","19":"add-to-list-drawer","20":"aisle-bay","21":"augmented-reality","22":"bath-renovation","23":"breadcrumbs","24":"browse-and-search","25":"browse-and-search-mobile","26":"buybox","27":"calculator-pipcalculator","28":"collections","29":"collections-mobile","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"fbr","37":"fulfillment","38":"global-custom-configurator","39":"hammerjs","41":"home","42":"magic-apron","43":"measurement-guide","44":"measurement-guide-overlay-content","45":"media-gallery-filmstrip-mobile","46":"media-gallery-overlay","47":"media-gallery-overlay-mobile","48":"message-types","49":"orange-lens","50":"order-sample","51":"order-sample-drawer","52":"overlay","53":"paint-reorder","54":"paint-reorder-mobile","55":"pep","56":"pep-mobile","57":"product","58":"product-mobile","59":"product-overview","60":"promotion-products-lazy","61":"question","62":"questions-and-answers","63":"quick-view","64":"ratings-and-reviews","65":"ratings-and-reviews-desktop","66":"ratings-and-reviews-mobile","67":"results","68":"returns-messaging","70":"share-to-email-overlay","71":"share-to-pinterest-overlay","72":"size-guide-overlay","73":"specifications","74":"stylequiz","75":"super-sku","76":"vendor-collection-products","77":"vendor-collections","78":"vendor-collections-mobile","80":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"2e28bfd49566f2b11bd8","1":"da5175fb6a46776b3bd3","2":"8b1749d6fb4ece51940d","3":"bb9a9c39909ba994f4b5","4":"f704e5fba69dc691ab8f","5":"691bfcb2ed8c2fe21788","6":"6f1646cb9d54951860b1","7":"9cf5449bba75db5264a9","8":"dc1721afe89d4f69da64","9":"bf7ab7ebd9aa3b5886a3","10":"0419507b3460a79584cf","11":"5b0f7f8d684df6842a5f","12":"6607d980d2e2c48c652b","13":"d8cddd6c525ba881d852","14":"79a5144f6d8f2c90774d","15":"096ad0e7991deb0d8fb5","16":"15e01b09695eb828d880","17":"7f6f82c700c4d442c6c3","18":"8845b0cbd88e46e68145","19":"996df03d077e64135137","20":"d7a54fe86571e9c51f5d","21":"b6da7cf83e83c40dd596","22":"b392c60875b57ec963ce","23":"9ebcafcaed3676246060","24":"b0a8ab81ab6835f140c1","25":"cb3763e9412344d84a9b","26":"cc8d9f383dbbbb7932cd","27":"a34f09868ab2fed2c744","28":"51edf831eaa4bc58ede6","29":"8ebf013f7572ae5efbc3","30":"da51c96f631f48cd03f7","31":"aadf686d7cd171035522","32":"6066a278ac2e69aee071","33":"7708c5fda947661f0e8a","34":"cd6a1eb4e973697d4247","35":"b1d1ea85103765e44237","36":"1cb37871e24ad90c688b","37":"90e219b00ebf86026dda","38":"947612ece7ed27032276","39":"81a134850ce14f6a1aa2","41":"e7a396bd86923d623c23","42":"3d933a743e85404663c6","43":"d1fe1b6ab05f64d1221d","44":"c95314d581fa53d38c46","45":"d835dfdd30e02fd1f1fd","46":"60020b0691491102b6c7","47":"df99f662dbc941be71be","48":"1c9cdde06a18bb908f42","49":"ab54ae904882d71c3e30","50":"c3e6d59f5ab0d9829690","51":"d9fab6a021b8ce5af342","52":"90e75562d1e1523c7ac3","53":"08b524872013d4e501f9","54":"81f950c6f3b88d8bd5b6","55":"6bceb5cbba815fb31bea","56":"d166d366c6c2bfbfd041","57":"5d97567733f5de0c0606","58":"7a914231faf32f17e010","59":"ef580857c1e17eb4d82f","60":"4e08a57bc46c8530601f","61":"5f26a4b5703477487e29","62":"b0fb3a170c72ca91e911","63":"5fc62780ab1b58382a60","64":"b5d7bfda2bc0e73bbbc0","65":"6cbe21048d94c2829f34","66":"512d82a370d1e40f385a","67":"dd676d3c58d027bba952","68":"a651ac3a9813b082c1a1","70":"1cd7f01773cc92d4078b","71":"49c32616ba177a148a04","72":"aa3d6f4eb4e521689571","73":"098c2f68d647c4b4616c","74":"5141e378d77f1ed3267d","75":"ebad0068398f3194e883","76":"ce0655730d6da2ebc5f4","77":"3f0f078eb4b68795225e","78":"dd26dc05d1fa984f4af1","80":"b95af2a6f686d9e138ff","81":"58c84f3cdd1ab5cd6142","82":"6fa784c8a5907e7078a8","83":"9a3c14d5c9aa80c60a14","84":"ba02787cdfb6a02f789d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"3":1,"5":1,"6":1,"8":1,"9":1,"10":1,"11":1,"12":1,"15":1,"16":1,"17":1,"20":1,"24":1,"25":1,"26":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"36":1,"37":1,"38":1,"42":1,"45":1,"46":1,"47":1,"49":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"62":1,"63":1,"64":1,"66":1,"72":1,"74":1,"75":1,"76":1,"77":1,"78":1,"80":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"buybox~collections~collections-mobile~fulfillment~paint-reorder~paint-reorder-mobile~pep~pep-mobile~~45c9a216","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","3":"browse-and-search~browse-and-search-mobile~buybox~collections~collections-mobile~media-gallery-overl~de52b3ab","4":"browse-and-search~browse-and-search-mobile~compare~orange-lens~product-mobile~vendor-collections~ven~4e47053e","5":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile~product-mobile","6":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","7":"BuyItAgainTypeaheadPreWrapper","8":"buybox~fulfillment~super-sku","9":"buybox~promotion-products-lazy~quick-view","10":"media-gallery-overlay~media-gallery-overlay-mobile~overlay","11":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","12":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","13":"add-to-list-drawer~orange-lens","14":"bath-renovation~consumer-card-messaging","15":"compare~orange-lens","16":"media-gallery-overlay~media-gallery-overlay-mobile","18":"StoreLayout","19":"add-to-list-drawer","20":"aisle-bay","21":"augmented-reality","22":"bath-renovation","23":"breadcrumbs","24":"browse-and-search","25":"browse-and-search-mobile","26":"buybox","27":"calculator-pipcalculator","28":"collections","29":"collections-mobile","30":"compare","31":"consumer-card-messaging","32":"customer-image-overlay","33":"drawer","34":"emt-generated-content","35":"emt-links","36":"fbr","37":"fulfillment","38":"global-custom-configurator","39":"hammerjs","41":"home","42":"magic-apron","43":"measurement-guide","44":"measurement-guide-overlay-content","45":"media-gallery-filmstrip-mobile","46":"media-gallery-overlay","47":"media-gallery-overlay-mobile","48":"message-types","49":"orange-lens","50":"order-sample","51":"order-sample-drawer","52":"overlay","53":"paint-reorder","54":"paint-reorder-mobile","55":"pep","56":"pep-mobile","57":"product","58":"product-mobile","59":"product-overview","60":"promotion-products-lazy","61":"question","62":"questions-and-answers","63":"quick-view","64":"ratings-and-reviews","65":"ratings-and-reviews-desktop","66":"ratings-and-reviews-mobile","67":"results","68":"returns-messaging","70":"share-to-email-overlay","71":"share-to-pinterest-overlay","72":"size-guide-overlay","73":"specifications","74":"stylequiz","75":"super-sku","76":"vendor-collection-products","77":"vendor-collections","78":"vendor-collections-mobile","80":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"668725f7e6ae2cbf0ccc","3":"83588448fb37280fe4ec","4":"31d6cfe0d16ae931b73c","5":"0ef658ad0521bc70e648","6":"58c38ec3c13b7afd0a80","7":"31d6cfe0d16ae931b73c","8":"370a6ea1c385f9f07fe0","9":"69a26af4764f55edec90","10":"71a6003147651c3739fd","11":"d486fddc1f6d9b29accc","12":"7c2eed0c18c49e42c517","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"9883292c450198dfc0ee","16":"9c6d11fbe8a42a3d0412","17":"65f73a002c9bc45ad240","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"86b1f984e52a6e02026d","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"f5414bab23f5eecead86","25":"aa186598884f4fb51998","26":"2f054b7e61fa0b21c57f","27":"31d6cfe0d16ae931b73c","28":"0d653a2896fd9419628f","29":"0317e1603853ee558731","30":"79724a33b3595b8623f3","31":"a699f2798a275b6729c8","32":"c466036523aec2558c34","33":"fc73174b407ad863c497","34":"b49004ddac99adec2224","35":"31d6cfe0d16ae931b73c","36":"88e24c7aafcf93ae6cc6","37":"ddf04856a4fe5106f34b","38":"1a5562a08d12f7682989","39":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"ceebf150d8a696023a14","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"c185dd507b97bcc2bd63","46":"e3f49663045d54d118c4","47":"d0c14165bd3e8683e416","48":"31d6cfe0d16ae931b73c","49":"89d9163eeb30e835d559","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"2f7c290bda28b11bb466","53":"fa2a6307c850c5a5e495","54":"b1c3593c1c01221173dc","55":"f23d11de799861a9dc76","56":"1e720f3136683f396e6f","57":"faa549cd35c1392cc7eb","58":"f0e93c84581cf01f1b6a","59":"be155bb5d11dacdc4bb8","60":"c9964da1755ce9a95535","61":"31d6cfe0d16ae931b73c","62":"d70c859b20e57c1599c5","63":"10bcc289761f77a0ae03","64":"78e5431cefd04f3f0002","65":"31d6cfe0d16ae931b73c","66":"11e50e2b1f3cfc88c5d6","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"453dfc2640779a848cc6","73":"31d6cfe0d16ae931b73c","74":"f5637400015ba731821d","75":"c391955109f2b07e5d49","76":"e518e335254638969e62","77":"e8cb558ced1f20d7954e","78":"858bff9dfa7d645cbfb7","80":"4a623c3bdc9f1a6eb8a5","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
